import { courses } from "./courses";
import { devices } from "./devices";
import { events } from "./events";
import { live } from "./live";
import { media } from "./media";
import { members } from "./members";
import { messages } from "./messages";
import { overview } from "./overview";
import { paywalls } from "./paywalls";
import { post_comments } from "./post_comments";
import { spaces } from "./spaces";
import { websites } from "./websites";

export const analytics = {
  devices,
  events,
  live,
  messages,
  members,
  overview,
  paywalls,
  media,
  post_comments,
  websites,
  spaces,
  courses,
};
